import { apiSlice } from '../api/apiSlice';

export const uploadApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadMultiple: builder.mutation({
      // Accepts a FormData instance containing the files under the 'images' key
      query: (formData) => ({
        url: '/upload/multiple',
        method: 'POST',
        body: formData,
      }),
    }),
  }),
});

export const { useUploadMultipleMutation } = uploadApiSlice;
